const getElementHeight = (element) => element.offsetHeight;

export default getElementHeight;
